module.exports = __webpack_public_path__ + "static/parisco-d7a889d9dc5fac5df1de15269972e4b2.png";